import { IApplicationState } from '../../types/redux';

export const genplanSeoPageUrlSelector = (state: IApplicationState): string => {
  return `${state.newbuilding.fullUrl}genplan/`;
};
